import { MotionDiv } from "../animations/components";
import { fadeInUp } from "../animations/variants";
import Logo from "../assets/images/orange-logo.svg";
import { BikesCalculator } from "../components/calculator/bikes-calculator";
import { ScContainer } from "../components/container/styled";
import { ScTitle } from "../components/title/styled";
import { ScBikesCalculatorHeader, ScBikesCalculatorLogo } from "./styled";

export const BikesCalculatorPage = () => (
  <>
    <ScContainer>
      <MotionDiv variants={fadeInUp}>
        <ScBikesCalculatorHeader>
          <ScTitle>See your savings</ScTitle>
          <a href="https://gogeta.com">
            <ScBikesCalculatorLogo src={Logo} alt="Gogeta" />
          </a>
        </ScBikesCalculatorHeader>
      </MotionDiv>
    </ScContainer>
    <BikesCalculator />
  </>
);
